<template>
  <div id="ssh-generate">
    <el-dialog
      title="Create a pair of cryptographic keys"
      width="70%"
      :visible.sync="localVisible"
      @close="$emit('update:visible', false)"
    >
      <el-alert
        type="error"
        title="You will generate a key only for this application"
        description="The private application key should be kept secure,
          with permissions set so that no other users on your computer can read the file."
        :closable="false"
      />

      <div class="generate">
        <el-button type="primary" @click="generate">Download your application key</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import fileSaver from 'file-saver'

export default {
  props: {
    visible: Boolean,
    applicationId: String,
    applicationName: {
      type: String,
      default: 'runstack'
    }
  },
  data () {
    return {
      loading: false,
      localVisible: this.visible,
      type: 'text/plain;charset=utf-8'
    }
  },
  methods: {
    generate () {
      this.loading = true
      this.$store.dispatch('generateApplicationKey', this.applicationId)
        .then((data) => {
          const filename = `${this.applicationName}.private.txt`
          fileSaver.saveAs(new Blob([data]), filename, { type: this.type })
          setTimeout(() => this.$store.dispatch('getApplications').catch(() => {}), 500)

          this.loading = false
          this.$emit('update:visible', false)
          this.$message({
            message: 'Please allow up to 60 seconds for changes to take effect on servers.',
            type: 'success'
          })
        })
    }
  },
  watch: {
    visible (value) {
      this.localVisible = value
    }
  }
}
</script>

<style lang="scss" scoped>
  .generate {
    margin-top: 25px;
    text-align: center;
  }
</style>
